export default "__VITE_ASSET__7ec065e9__"